<!-- FikoIsikYonselComponent - Dialog Core içinde render ediliyor -->
<div style="width:100%;min-width:400px;">
    <div style="padding: 5px;font-size: 0.75em;">

        <input class="fikoinput" type="text" #inputFikogram placeholder="İsmi" [ngModel]="nesne?.name"
            (ngModelChange)="nesne.name=inputFikogram.value;this.FikoYT.degisti.emit();">

        <textarea class="fikoinputAciklama" #inputFikogramAciklama placeholder="Açıklaması"
            [ngModel]="nesne?.userData.aciklama"
            (ngModelChange)="nesne.userData.aciklama=inputFikogramAciklama.value;this.FikoYT.degisti.emit();"></textarea>

        <!-- 🚗 Kamera Takip Modu -->
        <div style="margin-bottom: 8px;padding: 8px;background: rgba(255,255,255,0.05);border-radius: 4px;">
            <label style="display: block;margin-bottom: 5px;font-weight: 500;color:#fff;">
                🚗 Headlight Modu (FreeCAD/CATIA)
            </label>
            <div style="display: flex;align-items: center;gap: 8px;margin-bottom: 5px;">
                <input type="checkbox"
                    [ngModel]="nesne?.kameraTakipAktif"
                    (ngModelChange)="toggleKameraTakip()"
                    style="margin: 0;">
                <span style="color: #fff;">Kamerayı takip et</span>
            </div>
            <div *ngIf="nesne?.kameraTakipAktif" style="margin-top: 5px;">
                <label style="display: block;margin-bottom: 3px;color: #ccc;font-size: 0.9em;">
                    Kamera Offset Mesafesi: {{nesne?.kameraOffsetUzakligi}}
                </label>
                <input type="range"
                    [min]="10"
                    [max]="200"
                    [ngModel]="nesne?.kameraOffsetUzakligi"
                    [step]="5"
                    (ngModelChange)="setKameraOffsetUzakligi($event)"
                    style="width: 100%;"
                    [disabled]="!nesne?.kameraTakipAktif">
            </div>
        </div>

        <!-- Renk ve Parlaklık -->
        <div style="display: flex;align-items:center;gap:6px;margin-bottom: 6px;">
            <div>
                <input type="color" [ngModel]="'#'+nesne?.color.getHexString()"
                    (ngModelChange)="renkDegisti($event);" style="width: 2.5em;padding:0px !important;height:26px;"
                    tabindex="-1">
            </div>
            <div style="flex:1">
                <input type="range" [min]="0.01" [max]="20" tabindex="0" [ngModel]="nesne?.intensity"
                    [step]="0.1" (ngModelChange)="nesne.intensity=parseFloat($event);nesne.sahne.anaGosterim.ciz();"
                    style="width:100%;" />
            </div>
            <div style="min-width:45px;text-align:right;color:#fff;font-size:0.85em;font-weight:500;">{{(nesne?.intensity|number:'1.1-1')}}</div>
        </div>

        <!-- Konum -->
        <div style="margin-bottom: 6px;">
            <label style="display: block;margin-bottom: 3px;font-weight: 500;color:#fff;">
                📍 Manuel Offset <span [hidden]="!nesne?.kameraTakipAktif" style="color: #4CAF50;font-size: 0.8em;">(Kamera + Manuel)</span>
                <span [hidden]="nesne?.kameraTakipAktif" style="color: #FF9800;font-size: 0.8em;">(Manuel Mod)</span>
            </label>

            <div style="margin-bottom: 3px;">
                <label style="display: inline-block;width:30px;color:#fff;font-weight:500;">X:</label>
                <input type="range" [min]="-1000" [max]="1000" tabindex="0"
                    [ngModel]="nesne?.kameraTakipAktif ? nesne?.kameraManuelOffset.x : nesne?.position.x"
                    [step]="1" (ngModelChange)="manuelKonumDegisti('x', $event)"
                    style="width:calc(100% - 120px);vertical-align:middle;" />
                <span style="color:#fff;font-weight:500;margin-left:5px;min-width:40px;display:inline-block;text-align:right;font-size:0.85em;">
                    {{(nesne?.kameraTakipAktif ? (nesne?.kameraManuelOffset.x|number:'1.0-0') : (nesne?.position.x|number:'1.0-0'))}}
                </span>
                <button class="ui mini icon button"
                    style="margin-left: 5px; padding: 5px 8px; font-size: 0.7em;"
                    (click)="sifirlaOffset('x')"
                    title="X offset'i sıfırla">
                    <i class="refresh icon"></i>
                </button>
            </div>

            <div style="margin-bottom: 3px;">
                <label style="display:inline-block;width:30px;color:#fff;font-weight:500;">Y:</label>
                <input type="range" [min]="-1000" [max]="1000" tabindex="0"
                    [ngModel]="nesne?.kameraTakipAktif ? nesne?.kameraManuelOffset.y : nesne?.position.y"
                    [step]="1" (ngModelChange)="manuelKonumDegisti('y', $event)"
                    style="width:calc(100% - 120px);vertical-align:middle;" />
                <span style="color:#fff;font-weight:500;margin-left:5px;min-width:40px;display:inline-block;text-align:right;font-size:0.85em;">
                    {{(nesne?.kameraTakipAktif ? (nesne?.kameraManuelOffset.y|number:'1.0-0') : (nesne?.position.y|number:'1.0-0'))}}
                </span>
                <button class="ui mini icon button"
                    style="margin-left: 5px; padding: 5px 8px; font-size: 0.7em;"
                    (click)="sifirlaOffset('y')"
                    title="Y offset'i sıfırla">
                    <i class="refresh icon"></i>
                </button>
            </div>

            <div style="margin-bottom: 3px;">
                <label style="display:inline-block;width:30px;color:#fff;font-weight:500;">Z:</label>
                <input type="range" [min]="-1000" [max]="1000" tabindex="0"
                    [ngModel]="nesne?.kameraTakipAktif ? nesne?.kameraManuelOffset.z : nesne?.position.z"
                    [step]="1" (ngModelChange)="manuelKonumDegisti('z', $event)"
                    style="width:calc(100% - 120px);vertical-align:middle;" />
                <span style="color:#fff;font-weight:500;margin-left:5px;min-width:40px;display:inline-block;text-align:right;font-size:0.85em;">
                    {{(nesne?.kameraTakipAktif ? (nesne?.kameraManuelOffset.z|number:'1.0-0') : (nesne?.position.z|number:'1.0-0'))}}
                </span>
                <button class="ui mini icon button"
                    style="margin-left: 5px; padding: 5px 8px; font-size: 0.7em;"
                    (click)="sifirlaOffset('z')"
                    title="Z offset'i sıfırla">
                    <i class="refresh icon"></i>
                </button>
            </div>

            <!-- Hızlı Sıfırlama Butonları -->
            <div style="display: flex; gap: 5px; margin-top: 8px; justify-content: center;">
                <button class="ui mini button"
                    style="padding: 5px 10px; font-size: 0.75em; background: rgba(255,255,255,0.1);"
                    (click)="sifirlaTumOffset()"
                    title="Tüm offset'leri sıfırla">
                    🔄 Tümünü Sıfırla
                </button>
                <button class="ui mini button"
                    style="padding: 5px 10px; font-size: 0.75em; background: rgba(76,175,80,0.2);"
                    (click)="sifirlaKameraOffset()"
                    title="Kamera offset'ini sıfırla">
                    📷 Kamera Offset: {{nesne?.kameraOffsetUzakligi}}
                </button>
            </div>
        </div>

        <div style="text-align: right; margin-top: 10px;">
            <div class="ui animated mini button" tabindex="0" (click)="kapa()">
                <div class="visible content">Kapat</div>
                <div class="hidden content">
                    <i class="check icon"></i>
                </div>
            </div>
        </div>
    </div>
</div>